import { PublicKey, Connection } from '@solana/web3.js'

import { Wallet } from '@coral-xyz/anchor/dist/cjs/provider'
import { getLiquidationPoolStatePublicKey, HedgeProgram } from '../utils/HedgeConstants'
import { LiquidationPosition } from '../accounts/LiquidationPoolPosition'
import { LiquidationPoolEra } from '../accounts/LiquidationPoolEra'
import { LiquidationPoolState } from '../accounts/LiquidationPoolState'


export async function fetchLiquidationPoolState(
  connection: Connection,
  wallet: Wallet
): Promise<any> {
  const program = HedgeProgram(connection, wallet)

  const poolStateKey = await getLiquidationPoolStatePublicKey()
  const liquidationPoolState = await program.account.liquidationPoolState.fetch(poolStateKey)
  return liquidationPoolState
}

export async function fetchUserLiquidationPoolPosition(
  connection: Connection,
  wallet: Wallet,
  userWalletPublicKey: PublicKey
): Promise<LiquidationPosition[]> {
  console.log("loading pool positions")
  const program = HedgeProgram(connection, wallet)

  const positions = await program.account.liquidationPosition.all([
    { memcmp: { bytes: userWalletPublicKey.toString(), offset: 8 + 32 } },
    // Filter on Open positions: 1_u64
    // { memcmp:
    //   {
    //     bytes: base58.encode(Buffer.from([0])),
    //     offset: 8 + (32 * 2 ) + (16 * (128 * 2 + 3) + (8 * 4))
    //   }
    // },
  ])
  console.log('Positions', positions)
  const poolStateKey = await getLiquidationPoolStatePublicKey()
  const liquidationPoolState = await program.account.liquidationPoolState.fetch(poolStateKey)
  return Promise.all(
    positions.map(async (position) => {
      const era = await program.account.liquidationPoolEra.fetch(position.account.era)
      return new LiquidationPosition(
        position.account,
        position.publicKey,
        new LiquidationPoolEra(era),
        new LiquidationPoolState(liquidationPoolState)
      )
    })
  )
}

export async function fetchCurrentPoolEra(connection, wallet, userWalletPublicKey) {
  const program = HedgeProgram(connection, wallet)

  const poolStateKey = await getLiquidationPoolStatePublicKey()
  const liquidationPoolState = await program.account.liquidationPoolState.fetch(poolStateKey)
  const currentLiquidationPoolEra = await program.account.liquidationPoolEra.fetch(
    liquidationPoolState.currentEra
  )
  return new LiquidationPoolEra(currentLiquidationPoolEra)
}

export async function fetchCurrentPoolEraPublicKey(connection, wallet, userWalletPublicKey) {
  const program = HedgeProgram(connection, wallet)

  const poolStateKey = await getLiquidationPoolStatePublicKey()
  const liquidationPoolState = await program.account.liquidationPoolState.fetch(poolStateKey)
  return liquidationPoolState.currentEra
}
